var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossesDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40.280998mm",
    height: "10.377mm",
    viewBox: "0 0 40.280998 10.377",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "EMFhbasepattern",
    patternUnits: "userSpaceOnUse",
    width: 6,
    height: 6,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "EMFhbasepattern-2",
    patternUnits: "userSpaceOnUse",
    width: 6,
    height: 6,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "EMFhbasepattern-1",
    patternUnits: "userSpaceOnUse",
    width: 6,
    height: 6,
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text1183",
    style: {
      fontSize: "14.8001px",
      lineHeight: "125%",
      fontFamily: "'CS New Athanasius'",
      letterSpacing: 0,
      wordSpacing: 0,
      strokeWidth: 0.264583,
      fill: "currentColor"
    },
    transform: "translate(-58.357014,-109.84672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 64.362261,115.8446 h 1.286337 l 1.647667,1.43809 v -0.80215 l 1.394736,-1.47423 -1.416416,-1.42364 v -0.80216 l -1.625987,1.39474 h -1.286337 v -1.27911 l 1.401962,-1.62599 H 64.96207 l -1.423643,-1.42364 -1.467002,1.39473 h -0.809381 l 1.438096,1.6549 v 1.27911 h -1.293563 l -1.618761,-1.39474 v 0.80216 l -1.430869,1.42364 1.409189,1.47423 v 0.80215 l 1.640441,-1.43809 h 1.293563 v 1.34415 l -1.438096,1.64766 h 0.809381 l 1.467002,1.38751 1.423643,-1.40919 h 0.802153 l -1.401962,-1.62598 z",
    id: "path7874",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.3358,115.8446 h 1.286337 l 1.647667,1.43809 v -0.80215 l 1.394736,-1.47423 -1.416415,-1.42364 v -0.80216 l -1.625988,1.39474 H 79.3358 v -1.27911 l 1.401963,-1.62599 h -0.802154 l -1.423643,-1.42364 -1.467002,1.39473 h -0.80938 l 1.438095,1.6549 v 1.27911 h -1.293563 l -1.618761,-1.39474 v 0.80216 l -1.430869,1.42364 1.409189,1.47423 v 0.80215 l 1.640441,-1.43809 h 1.293563 v 1.34415 l -1.438095,1.64766 h 0.80938 l 1.467002,1.38751 1.423643,-1.40919 h 0.802154 L 79.3358,117.18875 Z",
    id: "path7876",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.309339,115.8446 h 1.286337 l 1.647668,1.43809 v -0.80215 l 1.394736,-1.47423 -1.416416,-1.42364 v -0.80216 l -1.625988,1.39474 h -1.286337 v -1.27911 l 1.401963,-1.62599 h -0.802154 l -1.423642,-1.42364 -1.467002,1.39473 h -0.809381 l 1.438096,1.6549 v 1.27911 h -1.293564 l -1.618761,-1.39474 v 0.80216 l -1.430869,1.42364 1.40919,1.47423 v 0.80215 l 1.64044,-1.43809 h 1.293564 v 1.34415 l -1.438096,1.64766 h 0.809381 l 1.467002,1.38751 1.423642,-1.40919 h 0.802154 l -1.401963,-1.62598 z",
    id: "path7878",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "3.88607px",
      lineHeight: "125%",
      fontFamily: "Aptos",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "start",
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    x: 69.645874,
    y: 120.12275,
    id: "text1189"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 69.645874,
    y: 120.12275,
    id: "tspan1187",
    style: {
      strokeWidth: 0.264583,
      fill: "currentColor"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    dx: 0,
    dy: 0,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "3.88607px",
      fontFamily: "Aptos",
      fill: "currentColor",
      strokeWidth: 0.264583
    },
    id: "tspan1185"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "10.5833px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    x: 64.001411,
    y: 115.03521,
    id: "text3412"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3410",
    style: {
      strokeWidth: 0.264583,
      fill: "currentColor"
    },
    x: 64.001411,
    y: 115.03521
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "14.8001px",
      lineHeight: "125%",
      fontFamily: "'CS New Athanasius'",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "start",
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    x: 59.300648,
    y: 131.71625,
    id: "text5001"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 59.300648,
    y: 131.71625,
    id: "tspan4999",
    style: {
      strokeWidth: 0.264583,
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "3.88607px",
      lineHeight: "125%",
      fontFamily: "Aptos",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "start",
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    x: 70.596802,
    y: 131.71625,
    id: "text5007"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70.596802,
    y: 131.71625,
    id: "tspan5005",
    style: {
      strokeWidth: 0.264583,
      fill: "currentColor"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    dx: 0,
    dy: 0,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "3.88607px",
      fontFamily: "Aptos",
      fill: "currentColor",
      strokeWidth: 0.264583
    },
    id: "tspan5003"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "3.88607px",
      lineHeight: "125%",
      fontFamily: "Aptos",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "start",
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    x: 69.645874,
    y: 131.41711,
    id: "text3427"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 69.645874,
    y: 131.41711,
    id: "tspan3425",
    style: {
      strokeWidth: 0.264583,
      fill: "currentColor"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    dx: 0,
    dy: 0,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "3.88607px",
      fontFamily: "Aptos",
      fill: "currentColor",
      strokeWidth: 0.264583
    },
    id: "tspan3423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossesDivider);
export default __webpack_public_path__ + "static/media/crossesDivider.9a01be7ff87facda3f72ea642528ea6d.svg";
export { ForwardRef as ReactComponent };